const LANGUAGES = {
	PL: {
		name: 'Polski',
		flag: 'pl',
	},
	EN: {
		name: 'English',
		flag: 'gb',
	},
	DE: {
		name: 'Deutsch',
		flag: 'de',
	},
	RO: {
		name: 'Română',
		flag: 'ro',
	},
} as const;

export default LANGUAGES;
